import { render, staticRenderFns } from "./EmojisLeftBar.vue?vue&type=template&id=662d6439&scoped=true"
import script from "./EmojisLeftBar.vue?vue&type=script&lang=js"
export * from "./EmojisLeftBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d6439",
  null
  
)

export default component.exports